import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import Header from '../Component/Header'
import Footer from '../Component/Footer'
function MissionVision() {
    useEffect(() => {
        document.title = 'About Us - Jai Rani Public School, Balussery';
    }, []);
    return (
        <>
            <Header />
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>
                    <li>About </li>
                    <li>Mission & Vision</li>
                </ul>
            </div>
            <div className="innersec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1>Mission & Vision</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mission-vision">
                            <div class="section-block">
                                <h3 class="section-title">Mission</h3>
                                {/* <p>
                                    Jai Rani SABS Public School serves students from Balussery and surrounding
                                    areas with high-quality education that inspires them to be lifelong learners and
                                    responsible global citizens. Through the collaboration of a dedicated faculty
                                    and a supportive community, we shape our students to be internationally minded,
                                    culturally sensitive, confident, and critical thinkers. They aspire to join
                                    leading universities and become leaders in their chosen fields. We support the
                                    globally mobile community by delivering world-class education rooted in values.
                                </p> */}
                                <p>To impart value-based education and scaffold young minds to the horizon of knowledge and wisdom.</p>
                            </div>
                            <div class="section-block">
                                <h3 class="section-title">Vision</h3>
                                <p>
                                    To empower our students to explore, expand, and enrich their potential, guiding
                                    them to become accountable, creative, compassionate, ethical, and responsible
                                    members of society.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default MissionVision